var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"icons"},_vm._l((_vm.modules),function(module){return _c('HomeLink',{key:module[0],attrs:{"module":module}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }